<script setup lang="ts">
import {Link} from "@inertiajs/vue3";
import ButtonComponent from "@components/button.vue";
import ProductTypeComponent from "@components/product-type.vue";
import {PropType} from "vue";
import {ProductsInterface} from "@interfaces/ProductsInterface.js";
import { trans } from 'laravel-vue-i18n';

let props = defineProps({
    preConfigs: {
        type: Array as PropType<ProductsInterface[]>,
        required: true
    },
    categorySlug: {
        type: String,
        required: true
    },
});

</script>
<template>
    <section id="home-section-products" class="container">
        <div class="grid">
            <article>
                <h2>
                    Standing desks
                </h2>
                <p>
                    {{ trans('pages.home.product_desc') }}
                </p>
            </article>
            <product-type-component
                :category_slug="props.categorySlug"
                :product="preconfig"
                v-for="preconfig in props.preConfigs"
                :key="preconfig.id"
            >
            </product-type-component>
        </div>
    </section>
</template>
<style scoped lang="scss">
@use "@scss/pages/home/sections/products";
</style>
